import { ExercisesReducerState } from '../reducers/exercisesReducer';

export const allExercisesSelector = ({ exercises }: { exercises: ExercisesReducerState }) =>
  exercises.allExercises;
